import { Component, EventEmitter, Input, Output } from "@angular/core"
import { animate, style, transition, trigger } from "@angular/animations"

export const slideIn = trigger("fadeSlideInOut", [
    transition(":enter", [
        style({ opacity: 0, transform: "translateY(-50px)" }),
        animate("300ms", style({ opacity: 1, transform: "translateY(5px)" })),
    ]),
    transition(":leave", [animate("300ms", style({ opacity: 0, transform: "translateY(-50px)" }))]),
])

@Component({
    selector: "app-burger-menu",
    templateUrl: "./burger-menu.component.html",
    styleUrls: ["./burger-menu.component.scss"],
})
export class BurgerMenuComponent {
    @Output() expandedState: EventEmitter<boolean> = new EventEmitter()
    @Input() menuTitle: string
    isMenuExpanded = false
    checkedState = false

    toggleCollapse() {
        this.isMenuExpanded = !this.isMenuExpanded
        this.expandedState.emit(this.isMenuExpanded)
        this.checkedState = !this.checkedState
    }
}
